import { __generator } from "tslib";
import { all, put, takeEvery, call, select } from 'redux-saga/effects';
import { URLS } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { popModal } from './basicActions';
import { pushBadgeModal, confirmYes, confirmNo, doNotShowAgainChanged, } from './actionCreators';
import { closeNotificationsDropdown } from '../../SiteHeader/redux/actions';
import { messageReceived } from '../../redux/messages/action';
import { createOrOpenChatWithUser } from '../../Chat/redux/actions';
import { getCurrentModal } from './selectors';
import { getCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/selectors';
import { CompliantLocalStorageKeys } from '../../redux/compliantLocalStorage/constants';
import { setCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/actions';
function handleBadgeModal(message) {
    var isInsideIframe;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                try {
                    isInsideIframe = window.self !== window.top;
                }
                catch (e) {
                    isInsideIframe = true;
                }
                // badge modal could be fired from the recent messages iframe in header
                if (isInsideIframe) {
                    return [2 /*return*/];
                }
                if (!(message.badgeName && message.userId)) return [3 /*break*/, 2];
                ddt.log('shared', 'firing pushBadgeModal', message);
                return [4 /*yield*/, put(pushBadgeModal(message.username, message.onBadgeSent))];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}
function handleGiveModal(message) {
    var iframe;
    return __generator(this, function (_a) {
        if (message.command === 'badge_receipt') {
            iframe = document.getElementById('eclipse-notifications-iframe');
            if (iframe && iframe.contentWindow) {
                // Notifications iframe is always hosted on www.deviantart.com
                // so target origin is URLS.ROOT
                iframe.contentWindow.postMessage(JSON.stringify(message), URLS.ROOT);
            }
        }
        return [2 /*return*/];
    });
}
function handleMessage(_a) {
    var _b;
    var message = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = message.type;
                switch (_b) {
                    case 'OpenBadgeModal': return [3 /*break*/, 1];
                    case 'GiveModal': return [3 /*break*/, 3];
                    case 'OpenChat': return [3 /*break*/, 5];
                }
                return [3 /*break*/, 9];
            case 1: return [4 /*yield*/, call(handleBadgeModal, message)];
            case 2:
                _c.sent();
                return [3 /*break*/, 9];
            case 3: return [4 /*yield*/, call(handleGiveModal, message)];
            case 4:
                _c.sent();
                return [3 /*break*/, 9];
            case 5: return [4 /*yield*/, put(createOrOpenChatWithUser("window-message-".concat(message.user.useridUuid), message.user))];
            case 6:
                _c.sent();
                if (!(message.source && message.source === 'messagecentre')) return [3 /*break*/, 8];
                return [4 /*yield*/, put(closeNotificationsDropdown())];
            case 7:
                _c.sent();
                _c.label = 8;
            case 8: return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function handleConfirmAnswer() {
    var modal;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getCurrentModal)];
            case 1:
                modal = _c.sent();
                if (((_b = (_a = modal === null || modal === void 0 ? void 0 : modal.options) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.closeOnConfirmation) === false) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(popModal())];
            case 2:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleDoNotShowAgainChanged(action) {
    var dnsDb, dnsItems, e_1, dnsItems;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 7]);
                return [4 /*yield*/, select(getCompliantLocalStorageItem, CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN)];
            case 1:
                dnsDb = _c.sent();
                dnsItems = void 0;
                if (!!dnsDb) return [3 /*break*/, 3];
                dnsItems = (_a = {},
                    _a[action.payload.key] = action.payload.value,
                    _a);
                return [4 /*yield*/, put(setCompliantLocalStorageItem({
                        key: CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN,
                        value: JSON.stringify(dnsItems),
                    }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3:
                dnsItems = JSON.parse(dnsDb);
                dnsItems[action.payload.key] = action.payload.value;
                return [4 /*yield*/, put(setCompliantLocalStorageItem({
                        key: CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN,
                        value: JSON.stringify(dnsItems),
                    }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 7];
            case 5:
                e_1 = _c.sent();
                dnsItems = (_b = {},
                    _b[action.payload.key] = action.payload.value,
                    _b);
                return [4 /*yield*/, put(setCompliantLocalStorageItem({
                        key: CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN,
                        value: JSON.stringify(dnsItems),
                    }))];
            case 6:
                _c.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(messageReceived, handleMessage),
                    takeEvery(confirmYes, handleConfirmAnswer),
                    takeEvery(confirmNo, handleConfirmAnswer),
                    takeEvery(doNotShowAgainChanged, handleDoNotShowAgainChanged),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map